import { Pipe, PipeTransform } from '@angular/core';
import { ITicketSector } from "libraries/service/resources/booking/interfaces/IGetBookings";
import {Coupon, RuleType} from "@afidium/ts-facade";
import {
    IRuleTypeWithSectorCoupon,
    ISectorArrayWithCoupon
} from "libraries/component/sectors-air-details-list/sectors-air-details-list.component";

@Pipe({
    name: 'getRelatedRules'
})
export class GetRelatedRulesPipe implements PipeTransform {
    public transform(rules: IRuleTypeWithSectorCoupon[], sectors: ITicketSector[]): RuleType {
        const sectorCoupons: string[] = sectors.map((sector: ITicketSector): string => {
            return sector.coupon ?
                `index_${sector.coupon.index}_ticketIndex_${sector.coupon.ticket ? sector.coupon.ticket.index : ''}_ticketIndex_${sector.coupon.ticket ? sector.coupon.ticket.number : ''}`:
                null;
        });
        return rules && rules.length ?
            rules.find((rule: IRuleTypeWithSectorCoupon): boolean => {
                const ruleCoupons: string[] = rule.sectorArrayWithCoupon.flatMap(
                    (sectorWithCoupon: ISectorArrayWithCoupon): string[] => {
                        return sectorWithCoupon.couponArray ?
                            sectorWithCoupon.couponArray.map((coupon:Coupon) => {
                                return `index_${coupon.index}_ticketIndex_${coupon.ticket ? coupon.ticket.index : ''}_ticketIndex_${coupon.ticket ? coupon.ticket.number : ''}`;
                            }):
                            null;
                    }
                );
                const rulesFound: number = ruleCoupons.filter((key: string): boolean => sectorCoupons.includes(key)).length;
                return rulesFound && rulesFound === sectorCoupons.length;
            }) : null;
    }
}
